var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 9.16669C12.5711 9.16669 14.25 7.48775 14.25 5.41669C14.25 3.34562 12.5711 1.66669 10.5 1.66669C8.42893 1.66669 6.75 3.34562 6.75 5.41669C6.75 7.48775 8.42893 9.16669 10.5 9.16669Z",
    stroke: "#9599A0",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.58325 18.3333C2.58325 14.8179 5.15617 11.5366 7.33325 10.8333C7.33325 10.8333 9.31242 12.9429 10.4999 14.3491L13.6666 10.8333C15.4478 11.0679 18.4166 14.8179 18.4166 18.3333",
    stroke: "#9599A0",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.33325 18.3333H19.6666",
    stroke: "#9599A0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/classroom.146e215d7789ec4ec4ec58f6f869c3c1.svg";
export { ForwardRef as ReactComponent };